import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const PoolIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="pool-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 19"
    className={twMerge('h-6 w-6 stroke-current', className)}
    {...props}
  >
    <path
      strokeMiterlimit="10"
      d="M20.2 12c-.8-.4-1.3-1-2.8-1-2.4 0-2.4 1.5-4.7 1.5-1.3 0-1.9-.4-2.5-.8m10 3.3c-.8-.5-1.4-1-2.8-1-2.4 0-2.4 1.4-4.7 1.4-1.3 0-1.9-.4-2.5-.8m10 3.2c-.8-.4-1.4-1-2.8-1-2.4 0-2.4 1.5-4.7 1.5-1.3 0-1.9-.5-2.5-.9m.6-5.3c-.8-.5-1.3-1-2.8-1-2.4 0-2.4 1.4-4.7 1.4-1.3 0-1.9-.4-2.5-.8m10 3.2c-.8-.4-1.3-1-2.8-1-2.4 0-2.4 1.5-4.7 1.5-1.3 0-1.9-.5-2.5-.8m10 3.2c-.8-.4-1.3-1-2.8-1-2.4 0-2.4 1.5-4.7 1.5-1.3 0-1.9-.5-2.5-.9m19.4-12H.8M11 12.2V3.4a2.2 2.2 0 1 1 4.5 0v2M4.7 12.3V3.4a2.2 2.2 0 1 1 4.5 0v2m-4.5 3h6.4"
    />
  </svg>
)
